import {
  CREATE_META_TAG,
  CREATE_META_TAG_FAILED,
  CREATE_META_TAG_SUCCESS,
  DELETE_META_TAG,
  DELETE_META_TAG_FAILED,
  DELETE_META_TAG_SUCCESS,
  GET_META_TAGS,
  GET_META_TAGS_FAILED,
  GET_META_TAGS_SUCCESS,
  HIDE_DELETE_TAG_MODAL,
  OPEN_DELETE_TAG_MODAL,
  RESET_META_TAGS,
  UPDATE_META_TAG,
  UPDATE_META_TAG_SUCCESS,
  UPDATE_META_TAG_FAILED,
  OPEN_MERGE_TAGS_MODAL,
  HIDE_MERGE_TAGS_MODAL,
  MERGE_META_TAGS,
  MERGE_META_TAGS_FAILED,
  MERGE_META_TAGS_SUCCESS,
  GET_TAG,
  GET_TAG_FAILED,
  GET_TAG_SUCCESS,
  RESET_TAG,
} from "./actionTypes"

const INIT_STATE = {
  metaTags: [],
  loading: false,
  error: "",
  deleteTagModalIsOpen: false,
  mergeTagsModalIsOpen: false,
  tableDataIsLoading: false,
  selectedTag: null,
}

const Tags = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_META_TAGS:
      return {
        ...state,
        loading: true,
        tableDataIsLoading: true,
      }
    case CREATE_META_TAG:
    case DELETE_META_TAG:
    case UPDATE_META_TAG:
    case MERGE_META_TAGS:
    case GET_TAG:
      return {
        ...state,
        loading: true,
      }
    case GET_META_TAGS_SUCCESS:
      return {
        ...state,
        metaTags: action.payload,
        loading: false,
        tableDataIsLoading: false,
      }
    case GET_META_TAGS_FAILED:
      return {
        ...state,
        loading: false,
        tableDataIsLoading: false,
      }
    case CREATE_META_TAG_FAILED:
    case DELETE_META_TAG_FAILED:
    case UPDATE_META_TAG_FAILED:
    case MERGE_META_TAGS_FAILED:
    case GET_TAG_FAILED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case RESET_META_TAGS:
      return {
        ...state,
        metaTags: [],
      }
    case CREATE_META_TAG_SUCCESS:
      return {
        ...state,
        metaTags: [...state.metaTags, action.payload],
        loading: false,
      }
    case DELETE_META_TAG_SUCCESS:
    case UPDATE_META_TAG_SUCCESS:
    case MERGE_META_TAGS_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case OPEN_DELETE_TAG_MODAL:
      return {
        ...state,
        deleteTagModalIsOpen: true,
      }
    case HIDE_DELETE_TAG_MODAL:
      return {
        ...state,
        deleteTagModalIsOpen: false,
      }
    case OPEN_MERGE_TAGS_MODAL:
      return {
        ...state,
        mergeTagsModalIsOpen: true,
      }
    case HIDE_MERGE_TAGS_MODAL:
      return {
        ...state,
        mergeTagsModalIsOpen: false,
      }
    case GET_TAG_SUCCESS:
      return {
        ...state,
        selectedTag: action.payload,
        loading: false,
      }
    case RESET_TAG:
      return {
        ...state,
        selectedTag: null,
      }
    default:
      return state
  }
}

export default Tags
